<template>
  <v-app>
      <StakingCard />
  </v-app>
</template>

<script>
import StakingCard from './components/StakingCard'
// import Layout from "./components/Layout.vue";
export default {
  name: 'App',

  components: {
    StakingCard
  },

  data: () => ({
    //
  }),
}
</script>

<style scoped>
#app {
  background: url('../public/background.png') no-repeat center center fixed !important;
  background-size: cover;
  /* background-color: #F9FCFF; */
}
</style>
